
export const closedRequestsPossibleStatus = ['closed', 'solved'];
export const statusFilterItems = [
        {
            value: 'completedRequests',
            label: 'Completed',
            testId: 'xtra-completed-requests',
            multi: 'checkbox',
            isSelected: true,
        },
        {
            value: 'inProgressRequests',
            label: 'In Progress',
            testId: 'xtra-inprogress-requests',
            multi: 'checkbox',
            isSelected: true,
        },
    ];
export const creatorFilterItems = [
        {
            isSelected: true,
            label: 'Me',
            multi: 'checkbox',
            testId: 'request-createdby-me',
            value: 'me',
        },
        {
            isSelected: false,
            label: 'Others',
            multi: 'checkbox',
            testId: 'request-createdby-others',
            value: 'others',
        },
    ];
export const CLOSE_REQUEST_STATUS = 'Completed';
export const INPROGRESS_REQUEST_STATUS = 'In Progress';
export const SHARED_WITH_USERS = 'Shared with users:';
export const SHARED_WITH_ACCOUNT = 'Shared with account';
export const OPEN_CATALOG_BUTTON_PATH = '/insights/placer-xtra/';

export const RANGE_DATE_FORMAT = 'MMM DD, YYYY';
export const REQUESTED_ON_DATE_FORMAT = 'MMM DD';

export const SHARE_SUCCESS_TITLE = 'Sent';
export const SHARE_SUCCESS_TEXT = 'Your report has been successfully shared.';
export const SHARE_SUCCESS_BUTTON_TEXT = 'Close';

export const OPEN_XTRA_CATALOG_BUTTON_TEXT = 'Open XTRA Catalog';

